import React, { useState } from "react";
import DatePicker from "react-datepicker";
import {FcCalendar} from 'react-icons/fc';
import "react-datepicker/dist/react-datepicker.css";

const DatePicker_Simple = (props) => {
  const [startDate, setStartDate] = useState(props.valueInField);
  const handleChange = (value, event) => {
    //alert("VAL: " + value + " EVENT: " + event.target.id)
    //console.log(typeof(value))
    //props.triggerUpdateInParent(props.id, value)
    //setStartDate(value)

    var value2;
    if (props.valueInField == "") value2 = value;
    else value2 = new Date(props.valueInField)
    //var value2 = new Date(props.valueInField)
    props.triggerUpdateInParent(props.id, value)
    setStartDate(value)
  };
  const CustomInput = React.forwardRef((props,ref) => {
    return (
      <input
        className={"date-picker-main"}
        onClick={props.onClick}
        value={props.value}
        type="text"
        readOnly={true}
        ref={ref}
      />
    )
})
  //alert("PRPS: " + props.id + " ")
  //const [startDate, setStartDate] = useState(new Date());
  //const [startDate, setStartDate] = useState();
  return (
    <div style={{maxHeight:'65px', textAlign: ''}}>
        
        <div>&nbsp;<DatePicker customInput={<CustomInput/>} dateFormat="MM-dd-yyyy" showTimeSelect={props.showTimeSelect} id={props.id} 
          selected={startDate} 
          minDate={props.minDate}
          onChange={(value, e) => handleChange(value, e)} />
        </div>
        <FcCalendar className={props.iconClassNameOverride ? props.iconClassNameOverride : "date-picker-icon"}/>
        <span className={props.labelClassNameOverride ? props.labelClassNameOverride : "date-picker-label"}>{props.label}</span>
        {props.required ? <span className="required-field-datepicker-simple">*</span> : <span className="unrequired-field">*</span>}
        
    </div>
  );
};

export default DatePicker_Simple;